import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { updateStructuredDataAvailability } from '../../helpers/structuredData'

/**
 * Component that monitors availability state and updates structured data availability accordingly.
 * This ensures that the JSON-LD structured data matches the UI state after frontend availability fetch.
 */
class StructuredDataAvailabilityUpdater extends Component {
  componentDidUpdate(prevProps) {
    const { partNumber, isAvailable, requestDone, errorDetail } = this.props

    // Only update when availability request is completed and we have new data
    const wasRequestPending = !prevProps.requestDone
    const hasNoError = !errorDetail

    if (wasRequestPending && requestDone && hasNoError && partNumber) {
      updateStructuredDataAvailability(partNumber, isAvailable)
    }
  }

  render() {
    return null // This component only handles side effects, no UI
  }
}

StructuredDataAvailabilityUpdater.propTypes = {
  partNumber: PropTypes.string.isRequired,
  isAvailable: PropTypes.bool.isRequired,
  requestDone: PropTypes.bool.isRequired,
  errorDetail: PropTypes.string
}

const mapStateToProps = (state, ownProps) => {
  const { partNumber } = ownProps
  const { availability = {} } = state
  const { data = {}, meta = {} } = availability
  const { requestDone = false, errorDetail = '' } = meta
  const { quantityAvailable = 0 } = data[partNumber] || {}

  // Follow the same availability logic as used throughout the app
  let isAvailable = true // Default to available (including on error)

  if (requestDone && !errorDetail) {
    isAvailable = quantityAvailable > 0
  }

  return {
    isAvailable,
    requestDone,
    errorDetail
  }
}

export default connect(mapStateToProps)(StructuredDataAvailabilityUpdater)
export { StructuredDataAvailabilityUpdater }
